import React from "react";
import PropTypes from "prop-types";

import { PieChart, pieArcLabelClasses } from "@mui/x-charts/PieChart";
import { useTranslation } from "react-i18next";

const DynamicPieChart = ({
  height,
  data,
  skipAnimation,
  radius,
  itemNb,
  valueFormatter,
  arcLabel,
  arcLabelMinAngle,
  colors,
}) => {
  const { i18n } = useTranslation();
  const isRTL = i18n.dir() === "rtl";

  return (
    <PieChart
      height={height}
      colors={colors}
      sx={{
        justifyContent: "center",
        direction: isRTL ? "rtl" : "ltr",
        [`& .${pieArcLabelClasses.root}`]: {
          fontWeight: 500,
          fontSize: "0.875rem",
        },
      }}
      series={[
        {
          data: data.slice(0, itemNb),
          innerRadius: radius,
          arcLabel: arcLabel || ((params) => `${params.value}%` ?? ""),
          arcLabelMinAngle: arcLabelMinAngle,
          valueFormatter: (params) => {
            return `${params.value}%`;
          },
        },
      ]}
      skipAnimation={skipAnimation}
    />
  );
};

DynamicPieChart.propTypes = {
  // Height of the chart (in pixels)
  height: PropTypes.number,
  // Array of data objects for the chart series
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
  // Boolean to determine whether to skip animation on render
  skipAnimation: PropTypes.bool,
  // Inner radius for the pie chart (if using donut style)
  radius: PropTypes.number,
  // Number of items to display from the series data
  itemNb: PropTypes.number,
  // Function to format the value labels
  valueFormatter: PropTypes.func,
  // Optional custom arc label function
  arcLabel: PropTypes.func,
  // Minimum angle for arc labels to be shown
  arcLabelMinAngle: PropTypes.number,

  colors: PropTypes.object,
};

DynamicPieChart.defaultProps = {
  height: 300,
  skipAnimation: false,
  radius: 50,
  itemNb: Infinity,
  valueFormatter: (value) => value,
  arcLabelMinAngle: 20,
};

export default DynamicPieChart;
